import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { Observable } from 'rxjs';
import { TaskResultGeneric } from '../../models/task-result-generic';
import { MaterialModel } from '../../models/material/material-model';
import { PagedResult } from '../../models/paged-result.model';
import { buildQueryString } from '../query-bulider.service';
import { MaterialQuery } from '../../models/material/material-query.model';

const MATERIAL_ENDPOINT = 'material';

@Injectable({
  providedIn: 'root',
})
export class MaterialBackendService {
  constructor(private http: HttpClient) {}

  public getMaterialList(materialQuery: MaterialQuery) {
    const query = buildQueryString(materialQuery);
    return this.http.get<TaskResultGeneric<PagedResult<MaterialModel>>>(
      AppConfig.settings.backend.url + MATERIAL_ENDPOINT + query
    );
  }

  public saveNewMaterial(
    newMaterial: MaterialModel
  ): Observable<TaskResultGeneric<MaterialModel>> {
    return this.http.post<TaskResultGeneric<MaterialModel>>(
      AppConfig.settings.backend.url + MATERIAL_ENDPOINT,
      newMaterial
    );
  }

  public saveChangedMaterial(
    changedMaterial: MaterialModel
  ): Observable<TaskResultGeneric<MaterialModel>> {
    return this.http.put<TaskResultGeneric<MaterialModel>>(
      AppConfig.settings.backend.url + MATERIAL_ENDPOINT,
      changedMaterial
    );
  }

  public deleteMaterial(
    material: MaterialModel
  ): Observable<TaskResultGeneric<MaterialModel>> {
    return this.http.delete<TaskResultGeneric<MaterialModel>>(
      AppConfig.settings.backend.url + MATERIAL_ENDPOINT + '/' + material.id
    );
  }
}
